module.exports = __webpack_public_path__ + "img/Angel.42af6f3f.jpg";